const En = 'en';
const De = 'de';
const Es = 'es';

export {
    En,
    De,
    Es,
};
